module.exports = __webpack_public_path__ + "static/media/unlink_off.4c95ae10.png";